import React,{Component} from 'react';
import { NavBar,InputItem,Toast,Modal} from 'antd-mobile';
import {inviting} from "../../../service/memberService";
import './style.less'
const topimg = require('../../../common/image/topimg.jpg');
const goshiyong = require('../../../common/image/goshiyong.png');

export default class InviteAdd extends Component{
    constructor(props) {
        super(props);
        this.state={
            mobile:"",
            modal:false,
        }
    }
    componentDidMount() {
    }
    invite(){
        if(this.state.mobile == ""){
            Toast.info("请输入手机号码！");
            return
        }
        //如果调用成功显示modal
        Toast.loading("正在加载",0);
        let params = {
            phone:this.state.mobile.replace(/\s/ig, ''),
            mType:1,
            id:this.props.match.params.userId
        };
        // return;
        inviting(params)
            .then((res)=>{
                Toast.hide();
                if(res.data.code == "000000"){
                    this.setState({modal:true})
                }else{
                    Toast.info(res.data.msg,2);
                }
            }).catch(function (error) {
                console.log(error);
            });
    }
    employ(){
        this.props.history.push('/focusPage')
    }
    render(){
        return(
            <div className="friendScreen">
                <div className="content">
                    <img src={topimg} alt=""/>
                    <div className="formBox">
                        <InputItem
                            clear
                            placeholder="手机号码"
                            type="phone"
                            onChange={(v)=>this.setState({mobile:v})}
                        >
                        </InputItem>
                        {/*<input type="text" placeholder="手机号码" value={this.state.mobile} />*/}
                        <button onClick={()=>this.invite()}>立即领取</button>
                        <p onClick={()=>this.props.history.push('/regulation')}>查看奖励规则<i className="icon iconfont icon-gengduo"></i></p>
                    </div>
                </div>
                <Modal
                    visible={this.state.modal}
                    className="inviteModal"
                >
                    <div className="">
                        <img src={goshiyong} alt=""/>
                        <i className="icon iconfont icon-danchuangguanbi" onClick={()=>this.setState({modal:false})}></i>
                        <button onClick={()=>this.employ()}>去使用</button>
                    </div>
                </Modal>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Member/InviteAdd/index.js